<template>
  <div class="mt-8 pb-0 text-center">
    <ProjectByLogos class="hidden-sm-and-down" />
    <p class="hidden-md-and-up mb-10">
      {{ $t('A_PROJECT_BY') }}
      {{ $t('SUPPORTERS') }}
    </p>
  </div>
</template>

<script>
import ProjectByLogos from '@/components/ProjectByLogos.vue';

export default {
  name: 'ProjectBy',
  components: {
    ProjectByLogos,
  },
};
</script>
